module.exports = __webpack_public_path__ + "static/media/wmatic.88f32691.png";